import React from 'react';

import discountIcon from '../../assets/images/campaign-discount-2.svg';

/** Figma tabler-icons / discount-2 — 32×32, #FFD682 (yellow-10). */
const DISCOUNT_ICON_SIZE_PX = 32;

const CampaignDiscountIcon = ({ className = 'h-8 w-8 shrink-0' }) => (
  <img
    src={discountIcon}
    alt=""
    className={className}
    width={DISCOUNT_ICON_SIZE_PX}
    height={DISCOUNT_ICON_SIZE_PX}
    aria-hidden
  />
);

export default CampaignDiscountIcon;
